import { Form } from '@rocketseat/unform';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';

import { Breadcrumbs, Title, WrapperFlex } from '@unimed-fesp/components';
import { format } from 'date-fns';
import produce from 'immer';
import FadeIn from '../../components/atoms/FadeIn';
import history from '../../services/history';

import FilterExtendsBeneficiarios from '../../components/organisms/FilterExtendsBeneficiarios';
import TabTableBeneficiarios from '../../components/organisms/TabTableBeneficiarios';
import { Creators as BeneficiaryActions } from '../../store/ducks/beneficiario';
import theme from '../../styles/theme';
import { Container } from './styles';

const ConsultaBeneficiariosNestle = () => {
  const dispatch = useDispatch();
  const filterExtendsParams = {
    query_type: 0,
    page: 1,
    count_per_page: 10,
    modality: 0,
    term: 0,
    beneficiary_wallet_number: 0,
    beneficiary_name: '',
    beneficiary_birthday: null,
    beneficiary_document_number: null,
    only_dependents: false,
  };
  const paginationDefaultParams = {
    pageNumber: 1,
    pageSize: 10,
  };
  const [filterParams, setFilterParams] = useState(filterExtendsParams);
  const [paginationParams, setPaginationParams] = useState(
    paginationDefaultParams
  );
  const [formErrors, setFormErrors] = useState({
    modality: '',
    cpf: '',
    term: '',
    beneficiaryName: '',
    codeCard: '',
  });
  const TYPE_FORMS = {
    'Modalidade + Termo + Nome': 1,
    'Codigo do Cartao': 2,
    'Nome + Tipo Beneficiario': 3,
    'Nome + Data Nascimento': 4,
    CPF: 5,
  };
  const cleanErrors = () => {
    setFormErrors({
      modality: '',
      cpf: '',
      term: '',
      beneficiaryName: '',
      codeCard: '',
    });
  };
  function handleData(data) {
    const newFilterParams = produce(filterParams, (draft) => {
      const typeForm = TYPE_FORMS[data.typeForm];
      draft.query_type = typeForm;
      draft.page = 0;

      switch (typeForm) {
        case 1:
          draft.modality = data.modality;
          draft.term = data.term;
          draft.beneficiary_name = data.beneficiaryName;
          break;
        case 2:
          draft.beneficiary_wallet_number = Number(data.codeCard);
          break;
        case 3:
          draft.beneficiary_name = data.beneficiaryName;
          draft.only_dependents = data.typeBeneficiary === 'Dependente';
          break;
        case 4:
          draft.beneficiary_name = data.beneficiaryName;
          draft.beneficiary_birthday = format(
            data.beneficiaryBirthday,
            'MM-dd-yyyy 00:00:00'
          );
          break;
        case 5:
          draft.beneficiary_document_number = data.cpf.replace(/[^\d]/g, '');
          break;
        default:
          throw new Error('Tipo de formulario inválido.');
      }
    });

    setFilterParams(newFilterParams);
    return newFilterParams;
  }
  const handleChangePage = (paramsPag) => {
    if (paramsPag.pageNumber <= 0) {
      const newPaginationParams = produce(paginationParams, (draft) => {
        draft.pageNumber = 1;
        draft.pageSize = paramsPag.pageSize;
      });
      setPaginationParams(newPaginationParams);
    }

    const newFilterParams = produce(filterParams, (draft) => {
      draft.page = paramsPag.pageNumber <= 0 ? 0 : paramsPag.pageNumber - 1;
      draft.count_per_page = paramsPag.pageSize;
    });

    dispatch(
      BeneficiaryActions.postDataBeneficiariesNestleRequest(newFilterParams)
    );
  };

  const handleSubmit = async (data) => {
    const typeForm = TYPE_FORMS[data.typeForm];
    let validationSchema;
    switch (typeForm) {
      case 1:
        validationSchema = Yup.object().shape({
          modality: Yup.string().required('Campo Obrigatório'),
          term: Yup.string().required('Campo Obrigatório'),
        });
        break;
      case 2:
        validationSchema = Yup.object().shape({
          codeCard: Yup.string()
            .min(13, 'O Cod. Cartão deve conter 13 dígitos')
            .max(13, 'O Cod. Cartão deve conter 13 dígitos')
            .required('O Cod. Cartão é Obrigatório'),
        });
        break;
      case 3:
        validationSchema = Yup.object().shape({
          beneficiaryName: Yup.string().required(
            'O Nome do beneficiário é Obrigatório'
          ),
        });
        break;
      case 4:
        validationSchema = Yup.object().shape({
          beneficiaryName: Yup.string().required(
            'O Nome do beneficiário é Obrigatório'
          ),
          beneficiaryBirthday: Yup.string().required('Obrigatório'),
        });
        break;
      case 5:
        validationSchema = Yup.object().shape({
          cpf: Yup.string()
            .min(11, 'O CPF deve ter no mínimo 11 dígitos')
            .max(11, 'O CPF deve ter no máximo 11 dígitos')
            .required('O CPF é Obrigatório'),
        });
        break;
      default:
        throw new Error('Invalid form type');
    }

    try {
      await validationSchema.validate(data, {
        abortEarly: false,
      });
      setFormErrors({});

      const params = handleData(data);
      dispatch(BeneficiaryActions.postDataBeneficiariesNestleRequest(params));
      setPaginationParams(paginationDefaultParams);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errorMessages = {};
        error.inner.forEach((err) => {
          errorMessages[err.path] = err.message;
        });
        setFormErrors(errorMessages);
      }
    }
  };

  return (
    <Container>
      <FadeIn>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text="consulta de beneficiários"
              color={theme.titleGray}
              fontSize={38}
              marginBottom={8}
            />
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              {
                path: 'Consulta de beneficiários',
                onNavigate: () => history.push('/novo/beneficiarios-nestle'),
              },
            ]}
          />
        </WrapperFlex>
        <WrapperFlex>
          <WrapperFlex column marginBottom={30} fullWidth>
            <Form onSubmit={handleSubmit}>
              <FilterExtendsBeneficiarios
                errorMessages={formErrors}
                cleanErrors={cleanErrors}
              />
            </Form>
          </WrapperFlex>
        </WrapperFlex>
        <WrapperFlex column>
          <TabTableBeneficiarios
            paginationParams={paginationParams}
            setPaginationParams={setPaginationParams}
            handleChangePage={handleChangePage}
          />
        </WrapperFlex>
      </FadeIn>
    </Container>
  );
};

export default ConsultaBeneficiariosNestle;
